import { useCallback, useState } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { useAuth } from "src/contexts/auth-provider";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { ADD_MODIFIER_ITEM } from "src/constants/mutations";
import { failureToast, successToast } from "src/utils/toasts";
import { AddModifierItemInput, ModifierItem } from "src/interfaces/modifier.interface";
import { useDispatch } from "react-redux";
import { add_modifier_item } from "src/store/features/modifier-items-slice";

export const useAddModifierItem = () => {
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();
  const dispatch = useDispatch();

  const [isAddingModifierItem, setIsAddingModifierItem] = useState(false);

  const addModifierItem = useCallback(async (addModifierItemInput: AddModifierItemInput) => {
    if (!hasRestaurant?.correlationId) {
       failureToast("Restaurant correlation ID is required");
       return null;
    }

    setIsAddingModifierItem(true);

    try {
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: ADD_MODIFIER_ITEM,
        variables: {
          addModifierItemInput,
        },
      });

      if (data?.data?.addModifierItem) {
        const newModifierItem: ModifierItem = data.data.addModifierItem;
        dispatch(add_modifier_item(newModifierItem));
        successToast("Modifier item added successfully");
        return newModifierItem;
      } else {
        throw new Error("Failed to add modifier item");
      }
    } catch (err) {
      console.error("Error adding modifier item:", err);
      return null;
    } finally {
      setIsAddingModifierItem(false);
    }
  }, [axBe, hasRestaurant?.correlationId, dispatch]);

  return {
    addModifierItem,
    isAddingModifierItem,
  };
};
